/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentLanguageEnum } from './ConversationalAgentLanguageEnum';
import {
  ConversationalAgentLanguageEnumFromJSON,
  ConversationalAgentLanguageEnumFromJSONTyped,
  ConversationalAgentLanguageEnumToJSON,
} from './ConversationalAgentLanguageEnum';
import type { Perturbation } from './Perturbation';
import { PerturbationFromJSON, PerturbationFromJSONTyped, PerturbationToJSON } from './Perturbation';

/**
 *
 * @export
 * @interface PerturbedConversationalAgentDataset
 */
export interface PerturbedConversationalAgentDataset {
  /**
   *
   * @type {number}
   * @memberof PerturbedConversationalAgentDataset
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PerturbedConversationalAgentDataset
   */
  datasetPath: string;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedConversationalAgentDataset
   */
  hasPredictions?: boolean;
  /**
   *
   * @type {number}
   * @memberof PerturbedConversationalAgentDataset
   */
  originalDataset: number;
  /**
   *
   * @type {Perturbation}
   * @memberof PerturbedConversationalAgentDataset
   */
  readonly perturbation: Perturbation;
  /**
   *
   * @type {number}
   * @memberof PerturbedConversationalAgentDataset
   */
  stateSchema?: number | null;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedConversationalAgentDataset
   */
  evaluateState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedConversationalAgentDataset
   */
  hasState?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PerturbedConversationalAgentDataset
   */
  hasTokenUsage?: boolean;
  /**
   *
   * @type {ConversationalAgentLanguageEnum}
   * @memberof PerturbedConversationalAgentDataset
   */
  language: ConversationalAgentLanguageEnum;
}

/**
 * Check if a given object implements the PerturbedConversationalAgentDataset interface.
 */
export function instanceOfPerturbedConversationalAgentDataset(
  value: object,
): value is PerturbedConversationalAgentDataset {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('datasetPath' in value) || value['datasetPath'] === undefined) return false;
  if (!('originalDataset' in value) || value['originalDataset'] === undefined) return false;
  if (!('perturbation' in value) || value['perturbation'] === undefined) return false;
  if (!('language' in value) || value['language'] === undefined) return false;
  return true;
}

export function PerturbedConversationalAgentDatasetFromJSON(json: any): PerturbedConversationalAgentDataset {
  return PerturbedConversationalAgentDatasetFromJSONTyped(json, false);
}

export function PerturbedConversationalAgentDatasetFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PerturbedConversationalAgentDataset {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    datasetPath: json['dataset_path'],
    hasPredictions: json['has_predictions'] == null ? undefined : json['has_predictions'],
    originalDataset: json['original_dataset'],
    perturbation: PerturbationFromJSON(json['perturbation']),
    stateSchema: json['state_schema'] == null ? undefined : json['state_schema'],
    evaluateState: json['evaluate_state'] == null ? undefined : json['evaluate_state'],
    hasState: json['has_state'] == null ? undefined : json['has_state'],
    hasTokenUsage: json['has_token_usage'] == null ? undefined : json['has_token_usage'],
    language: ConversationalAgentLanguageEnumFromJSON(json['language']),
  };
}

export function PerturbedConversationalAgentDatasetToJSON(
  value?: Omit<PerturbedConversationalAgentDataset, 'id' | 'perturbation'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    dataset_path: value['datasetPath'],
    has_predictions: value['hasPredictions'],
    original_dataset: value['originalDataset'],
    state_schema: value['stateSchema'],
    evaluate_state: value['evaluateState'],
    has_state: value['hasState'],
    has_token_usage: value['hasTokenUsage'],
    language: ConversationalAgentLanguageEnumToJSON(value['language']),
  };
}
